import { Button, Spinner, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import cameraDisconnectedIcon from 'src/assets/icons/camera-disconnected.svg';

import SmallModalTemplate from 'src/components/SmallModalTemplate';

import { I18NextNS } from 'src/models/Language.model';

import CameraReconnectionFailedCard from './CameraReconnectionFailedCard';
import TroubleshootingStepsCard from './TroubleshootingStepsCard';

interface CameraConnectionIssueModalProps {
  show: boolean;
  shouldShowFailedCard: boolean;
  isCheckingConnection: boolean;
  handleCheckConnection: () => void;
  secondaryButton: React.ReactNode;
}

export default function CameraConnectionIssueModal({
  show,
  shouldShowFailedCard,
  isCheckingConnection,
  handleCheckConnection,
  secondaryButton,
}: CameraConnectionIssueModalProps) {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'cameraConnectionIssue.cameraConnectionIssueModal',
  });

  return (
    <SmallModalTemplate
      show={show}
      icon={<img src={cameraDisconnectedIcon} alt={t('cameraImgAlt')} />}
      iconWrapperClassName="bg-danger-100"
      title={t('title')}
      description={t('description')}
      backdropClassName="connection-issue-backdrop"
      style={{ zIndex: 2000 }}
      card={
        <Stack gap={3}>
          <TroubleshootingStepsCard />
          {shouldShowFailedCard && <CameraReconnectionFailedCard />}
        </Stack>
      }
      leftButton={secondaryButton}
      rightButton={
        isCheckingConnection ? (
          <Button variant="primary" className="button-slim" disabled>
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="me-2"
              />
              {t('retryingConnection')}
            </>
          </Button>
        ) : (
          <Button
            variant="primary"
            className="button-slim"
            onClick={handleCheckConnection}
          >
            {t('retryConnection')}
          </Button>
        )
      }
    />
  );
}
